
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: 'SignUpReportSuccessModal',
  emits: ["close"],
  methods: {
    ...mapActions(['toggleSignUpReportSuccessModal']),
    closeModal() {
      document.body.classList.remove("is-popup-opened");
      document.body.classList.add("is-popup-closed");
      setTimeout(() => {
        this.toggleSignUpReportSuccessModal();
        document.body.classList.remove("is-popup-closed");
      }, 250);
    },
    goToProcedures() {
      this.closeModal()
      this.$router.push({ path: '/procedures', query: { page: '1' }})
    }
  },
  computed: {
    ...mapGetters(['showSignUpReportSuccessModal']),
    title(): string {
      return this.$t('reports.sign_up_success')
    }
  },
});
